// src/components/ActivityConfigModal.js
import React, { useState, useEffect } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions, Button,
    TextField, IconButton, Box, Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ActivityTrackerEditor, { DEFAULT_TRACKER_CONFIG } from './content_editor/ActivityTrackerEditor';

const ActivityConfigModal = ({ open, onClose, config: initialConfig, initialName = "", onSave }) => {
    const [name, setName] = useState("");
    const [config, setConfig] = useState({});

    useEffect(() => {
        if (open) {
            setName(initialName || "");
            
            // FORCE INITIALIZATION:
            // If initialConfig exists, use it. 
            // If NOT, use DEFAULT_TRACKER_CONFIG immediately. 
            // This ensures the "config" state variable is never empty.
            if (initialConfig && Object.keys(initialConfig).length > 0) {
                setConfig(initialConfig);
            } else {
                setConfig(JSON.parse(JSON.stringify(DEFAULT_TRACKER_CONFIG)));
            }
        }
    }, [open, initialConfig, initialName]);

    const handleSave = () => {
        if (!name.trim()) {
            alert("Please provide a name for this tracker (e.g., 'CPAP Log', 'Brace Timer').");
            return;
        }
        onSave({ name, config });
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                {initialName ? 'Edit Tracker Settings' : 'Configure New Tracker'}
                <IconButton onClick={onClose}><CloseIcon /></IconButton>
            </DialogTitle>
            
            <DialogContent dividers>
                <Box sx={{ mb: 3 }}>
                    <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold' }}>
                        1. Tracker Name
                    </Typography>
                    <TextField
                        autoFocus
                        label="Name appearing on Patient Dashboard"
                        placeholder="e.g. Left Knee Brace, CPAP Machine, PT Exercises"
                        fullWidth
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        helperText="This is the title the patient will see."
                    />
                </Box>

                <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold', mt: 2 }}>
                    2. Data Entry Configuration
                </Typography>
                <ActivityTrackerEditor 
                    config={config} 
                    onChange={setConfig} 
                />
            </DialogContent>
            
            <DialogActions sx={{ p: 2 }}>
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={handleSave} variant="contained" color="primary">
                    {initialName ? 'Save Changes' : 'Add Tracker to Plan'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ActivityConfigModal;